<template>
  <v-container fluid class="pa-0 mb-0">
    <v-card
      elevation="0"
      height="auto"
      class="mb-2"
      v-for="(item, idx) in sidoList"
      v-bind:key="'sido_'+idx"
    >
      <v-card-title style="flex-wrap: nowrap;">
        <img class="mr-2" :src="chargeImage(item.TYPE)" alt>
        <span class="toShort">{{item.DESCRIPTION}}</span>
      </v-card-title>
      <v-card-title class="pt-0 cardTxtStyle pa-3">
        <v-row class="pl-2 pr-2 mb-2" style="width: 100%;">
          <v-col cols="4" class="pa-0">
            <v-card class="flex-column pa-0" elevation="0">
              <v-col class="pa-0 justify-center d-flex">발전량</v-col>
              <v-col class="pa-0 justify-center d-flex">{{ item.PVPCS_Pac | v_fixed }}</v-col>
            </v-card>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-card class="flex-column pa-0" elevation="0">
              <v-col class="pa-0 justify-center d-flex">당일발전량</v-col>
              <v-col class="pa-0 justify-center d-flex">{{ item.PVPCS_Daily_P | v_fixed }}</v-col>
            </v-card>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-card class="flex-column pa-0" elevation="0">
              <v-col class="pa-0 justify-center d-flex">전일발전량</v-col>
              <v-col class="pa-0 justify-center d-flex">{{ item.Yester }}</v-col>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="d-flex px-2" justify="space-around">
          <v-col cols="3" class="pa-0">
            <v-btn
              class="full-width font-size-09rem"
              small
              id="infoBtn"
              color="#0784F2"
              v-on:click="locationMap(item.SITE_ID)"
              style="color: white;"
            >지도</v-btn>
          </v-col>
          <v-col cols="3" class="pa-0">
            <v-btn
              v-if="item.CCTV_STAT !== 'N' && item.CCTV_STAT !== null"
              class="full-width font-size-09rem"
              small
              id="infoBtn"
              color="#0784F2"
              v-on:click="goCctv(item.SITE_ID, item.CCTV_CNT)"
              style="color: white;"
            >CCTV</v-btn>
          </v-col>
          <v-col cols="3" class="pa-0">
            <v-btn
              class="full-width font-size-09rem"
              small
              id="infoBtn"
              color="#0784F2"
              v-on:click="goUrl('detail', item.SITE_ID)"
              style="color: white;"
            >상세보기</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      v-if="viewPopup"
      v-model="viewPopup"
      persistent
      max-width="600px"
    >
      <cctv-popup
        @closeDetailPop="viewPopup=false"
        :cctv-cnt="infosData.CCTV_CNT"
        :site-id="infosData.SITE_ID"
      ></cctv-popup>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getMonitoringPersonal,
  getMonitoringYesterDay
} from '@/api/monitoring/monitoring.js'
import store from '@/store'
import day from 'dayjs'
import cctvPopup from '@/views/pc/site/CctvPopup'

export default {
  name: 'privateplant',
  components: {
    cctvPopup
  },
  props: {
    title: {
      default: '',
      type: String
    },
    infoData: {
      type: Object,
      default: () => {
        return {
          siteId: 'M2189',
          DESCRIPTION: '홍성 발전소',
          title: '테스트 홍성 지정리 지정3호태양광',
          LOCATION: '테스트 충청남도 홍성군 구항면 지정리 129',
          date: day('2020-11-13T15:00:00.000+0000').format('YYYY년 MM월 DD일'),
          charge: '유료',
          cctvView: false,
          TYPE: '유료',
          CCTV_CNT: 1
        }
      }
    }
  },
  data() {
    return {
      charge: require('@/assets/image/monitoring/mark-charge.png'),
      free: require('@/assets/image/monitoring/mark-free.png'),
      sidoList: [],
      saveAllRes: [],
      viewPopup: false,
      infosData: {
        CCTV_CNT: 0,
        SITE_ID: ''
      },
      interval: null,
      intervalTime: 60000 * 2 // 60000 * 2 2분
    }
  },
  filters: {
    v_fixed: r => {
      return r ? r.toFixed(1) : 0
    }
  },
  computed: {
    installDate() {
      return day(this.infoData.CRT_DATE).format('YYYY년 MM월 DD일')
    },
    cctvView() {
      return this.infoData.CCTV_CNT > 0
    }
  },
  created() {},
  mounted() {
    const _this = this
    _this.getData()
    _this.interval = setInterval(function() {
      _this.getData()
    }, _this.intervalTime)
  },
  methods: {
    getData() {
      const _this = this
      getMonitoringPersonal(
        store.state.user.userId,
        _this.$route.query.sido,
        _this.$route.query.sigu
      ).then(res => {
        _this.sidoList = res
        _this.getYesterDayData()
      })
    },
    goCctv(SITE_ID, CCTV_CNT) {
      this.infosData.SITE_ID = SITE_ID
      this.infosData.CCTV_CNT = CCTV_CNT
      this.viewPopup = true
    },
    locationMap(d) {
      // this.$router.push({ name: 'MobileLocationMap', query: { site_id: d } })
      this.$router.push('/mobile/locationMap?site_id=' + d)
    },
    async getYesterDayData() {
      let nLoop
      this.saveAllRes = []
      let _sidoData = this.sidoList
      for (nLoop = 0; nLoop < _sidoData.length; nLoop++) {
        if (_sidoData[nLoop].SITE_ID) {
          console.log('###############################')
          console.log(_sidoData[nLoop].SITE_ID)
          let res = await getMonitoringYesterDay(_sidoData[nLoop].SITE_ID)
          if (res.length > 0) {
            let sum = 0
            for (let j = 0; j < res.length; j++) {
              sum += res[j].PVPCS_Daily_P
            }
            _sidoData[nLoop].Yester = Number(sum).toFixed(1)
            this.saveAllRes.push(res[0].PVPCS_Daily_P)
          } else {
            _sidoData[nLoop].Yester = 0
            this.saveAllRes.push(0)
          }
        }
      }
      this.sidoList = _.cloneDeep(_sidoData)
    },
    chargeImage(i) {
      if (i === '유료') {
        return this.charge
      } else {
        return this.free
      }
    },
    goUrl(p, id) {
      if (p === 'cctv') {
        this.$router.push('/mobile/cctvList?site_id=' + id)
      } else if (p === 'detail') {
        if (id.substr(0, 1) === 'E') {
          // ESS
          this.$router.push('/mobile/ess/siteWork?site_id=' + id)
        } else {
          this.$router.push('/mobile/siteWork?site_id=' + id)
        }
      }
    }
  }
}
</script>

<style scoped>
.full-width {
  width: 100% !important;
}
.font-size-09rem {
  font-size: 0.9rem;
}
.toShort {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.cardTxtStyle {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: var(--v-btntext-base);
}
</style>
